import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import { ActionTypes } from "../Constants/ActionTypes";

export const setDeletedVideos = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_STORAGE_MANAGEMENT_LOADING,
    payload: true,
  });
  userService
    .getAllDeletedMedia(payload.userId, payload.page, payload.pageSize)
    .then((res) => {
      dispatch({
        type: ActionTypes.SET_DELETED_VIDEOS,
        payload: {
          data: res.data.data,
          page: payload.page,
          isVideoRestored: payload.isVideoRestored,
        },
      });
      dispatch({
        type: ActionTypes.SET_UNSEARCH_RECORD,
        payload: {},
      });
      dispatch({
        type: ActionTypes.SET_STORAGE_MANAGEMENT_LOADING,
        payload: false,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const removeDeletedVideos = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.REMOVE_DELETED_VIDEOS,
    payload: [],
  });
};

export const deleteVideoFromStorageManagement = (dispatch, payload) => {
  userService
    .deleteVideoPermanently(payload.videoIds, payload.userId)
    .then((res) => {
      if (!payload.isRecordSearched) {
        setDeletedVideos(dispatch, {
          userId: payload.userId,
          page: payload.page,
          pageSize: payload.pageSize,
          isVideoRestored: true,
        });
      } else {
        setSearchedVideos(dispatch, {
          userId: payload.userId,
          searchString: payload.searchQuery,
          page: 0,
          pageSize: payload.pageSize,
          isVideoRestored: true,
        });
      }
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: {
          open: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Deleted Successfully",
            open: true,
          },
        },
      });
      dispatch({
        type: ActionTypes.UNSELECT_ALL_VIDEO_ON_STORAGE_MANAGEMENT,
        payload: {},
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const selectUnselectVideoFromStorageManagement = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SELECT_UNSELECT_VIDEO_ON_STORAGE_MANAGEMENT,
    payload: payload,
  });
};

export const unSelectAllVideoFromStorageManagement = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.UNSELECT_ALL_VIDEO_ON_STORAGE_MANAGEMENT,
    payload: payload,
  });
};

export const restoreDeletedVideos = (dispatch, payload) => {
  userService
    .restoredDeletedNedia(payload.videoIds)
    .then((data) => {
      if (data.status === 200) {
        if (!payload.isRecordSearched) {
          setDeletedVideos(dispatch, {
            userId: payload.userId,
            page: 0,
            pageSize: payload.pageSize,
            isVideoRestored: true,
          });
        } else {
          setSearchedVideos(dispatch, {
            userId: payload.userId,
            searchString: payload.searchQuery,
            page: 0,
            pageSize: payload.pageSize,
            isVideoRestored: true,
          });
        }
        dispatch({
          type: ActionTypes.RESTORE_DELETED_VIDEOS,
          payload: payload,
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: "Video Restored Successfully",
              open: true,
            },
          },
        });
        dispatch({
          type: ActionTypes.UNSELECT_ALL_VIDEO_ON_STORAGE_MANAGEMENT,
          payload: {},
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const setSearchedVideos = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_STORAGE_MANAGEMENT_LOADING,
    payload: true,
  });
  userService
    .searchVideos(
      payload.userId,
      payload.searchString,
      payload.page,
      payload.pageSize
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.SEARCH_VIDEOS,
        payload: {
          data: res.data.data,
          page: payload.page,
          isVideoRestored: payload.isVideoRestored,
        },
      });
      dispatch({
        type: ActionTypes.SET_STORAGE_MANAGEMENT_LOADING,
        payload: false,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const setUnSearchRecord = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_UNSEARCH_RECORD,
    payload: {},
  });
};
